<div class="wrap-collabsible">
  <input #searchToggle id="collapsible" class="toggle" type="checkbox" (click)="loadCountryPropritydropdowm()" />
  <!-- <input #searchToggle id="collapsible" class="toggle" type="checkbox" (click)="loadPriorities()" /> -->
  <label for="collapsible" class="lbl-toggle">{{ 'search.search_cases' | translate }}</label>
  <div class="collapsible-content">
    <div class="content-inner">
      <ng-template ngIf="activeAccordion" class="slds-grid slds-grid_vertical-align-center slds-m-left_small">
        <form [formGroup]="filtersForm" class="cases-filters slds-grid slds-grid_vertical-align-center slds-gutters">
          <div class="slds-col slds-size_1-of-5">
            <ngl-select [label]="'search.type' | translate">
              <select ngl formControlName="casesFrom">
                <option [value]="casesType.ALLCASES">{{ 'search.allCases' | translate }}</option>
                <option [value]="casesType.MYCASES">{{ 'search.myCases' | translate }}</option>
              </select>
            </ngl-select>
          </div>
          <div class="slds-col slds-size_1-of-5">
            <ngl-select [label]="'search.country' | translate">
              <select ngl name="countries" formControlName="country">
                <option [value]="null" selected>{{ 'search.allCountries' | translate }}</option>
                <option *ngFor="let country of countries" [value]="country.apiName">{{ country.name }}</option>
              </select>
            </ngl-select>
          </div>
          <div class="slds-col slds-size_1-of-5">
            <ngl-select [label]="'createCase.Priority' | translate">
              <select ngl name="priorities" formControlName="priority">
                <option [value]="null" selected>{{ 'search.allPriorities' | translate }}</option>
                <option *ngFor="let priority of priorities" [value]="priority.apiName">{{ priority.name }}</option>
              </select>
            </ngl-select>
          </div>
          
          <div class="slds-col slds-size_1-of-5">
            <ngl-input fieldLevelHelpTooltip="{{ 'search.tooltip_search' | translate }}">
              <input
                formControlName="searchText"
                ngl
                type="input"
                placeholder="{{ 'search.searchText' | translate }}"
                (keyup.enter)="filterCases()"
              />
            </ngl-input>
          </div>
          <div class="slds-col slds-size_1-of-5 slds-m-top_large submit-btn">
            <button type="submit" (click)="filterCases()" nglButton>{{ 'search.button' | translate }}</button>
          </div>
        </form>

        <ng-container *ngIf="searchReady">
          <div class="slds-col slds-size_12-of-12 slds-m-vertical_x-small">
            <ul class="slds-list_horizontal">
              <li>
                <ngl-select #mySelect [label]="'syncReport.rowsPerPage' | translate">
                  <select [(ngModel)]="recordsPerPage" ngl (change)="recordsPerPageChange()">
                    <option [value]="10">10</option>
                    <option [value]="20">20</option>
                    <option [value]="50">50</option>
                  </select>
                </ngl-select>
              </li>
            </ul>
          </div>
          <table
            class="slds-table_bordered slds-max-medium-table_stacked-horizontal slds-table_fixed-layout"
            ngl-datatable
            [data]="data"
            [(sort)]="sort"
            (sortChange)="onSort($event)"
          >
            <ngl-datatable-column
              [heading]="'createCase.First_Name' | translate"
              key="firstName"
              [sortable]="true"
            ></ngl-datatable-column>
            <ngl-datatable-column
              [heading]="'createCase.Last_Name' | translate"
              key="lastName"
              [truncate]="true"
              [sortable]="true"
            ></ngl-datatable-column>
            <ngl-datatable-column
              [heading]="'createCase.Primary_Phone' | translate"
              key="primaryPhone"
              [truncate]="true"
              [sortable]="true"
            >
              <ng-template nglDatatableCell let-value>
                {{ value?.internationalNumber }}
              </ng-template>
            </ngl-datatable-column>
            <ngl-datatable-column
              [heading]="'createCase.AccountNumber' | translate"
              key="accountNumber"
              [sortable]="true"
            ></ngl-datatable-column>
            <ngl-datatable-column
              [heading]="'search.country' | translate"
              key="country"
              [truncate]="true"
              [sortable]="true"
            ></ngl-datatable-column>
            <ngl-datatable-column
              [heading]="'createCase.Priority' | translate"
              key="priority"
              [truncate]="true"
              [sortable]="true"
            ></ngl-datatable-column>
            <ngl-datatable-column [heading]="'search.createDate' | translate" key="createDate" [sortable]="true">
              <ng-template nglDatatableCell let-value>
                {{ value | date }}
              </ng-template>
            </ngl-datatable-column>
            <ngl-datatable-column key="id">
              <ng-template nglDatatableCell let-value>
                <button
                  class="slds-m-right_small"
                  type="button"
                  nglButton
                  variant="outline-brand"
                  iconName="utility:edit"
                  routerLink="/case/{{ value }}"
                  [queryParams]="{ navigationHistory: true }"
                >
                  {{ 'search.edit' | translate }}
                </button>
              </ng-template></ngl-datatable-column
            >
            <ng-template nglLoadingOverlay>
              <div class="slds-box slds-box_small slds-theme_shade slds-text-align_center">
                {{ 'general.loading' | translate }}
              </div>
            </ng-template>
            <ng-template nglNoRowsOverlay>{{ 'search.noCasesFound' | translate }}</ng-template>
          </table>
          <div class="slds-grid slds-grid_vertical-align-center">
            <div class="slds-grid slds-align_absolute-center slds-m-top_medium">
              <button
                type="button"
                nglButton
                variant="brand"
                [disabled]="currentPage === 1"
                (click)="pageChange(false)"
              >
                Previous
              </button>
              <button
                type="button"
                nglButton
                variant="brand"
                [disabled]="recordsPerPage * currentPage > totalRecords"
                (click)="pageChange(true)"
              >
                Next
              </button>
            </div>
          </div>
          <div class="slds-grid slds-grid_vertical-align-center">
            <div
              class="slds-col slds-size_12-of-12 slds-m-top_x-small slds-align_absolute-center"
              *ngIf="totalRecords > 1"
            >
              {{ 'search.showing' | translate }} {{ recordsPerPage * currentPage - (recordsPerPage - 1) }} -
              {{ recordsPerPage * currentPage > totalRecords ? totalRecords : recordsPerPage * currentPage }}
              {{ 'search.of' | translate }}
              {{ totalRecords }}
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
